import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/web/node_modules/next/dist/client/app-dir/link.js");
